import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShareOs: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconShareOs"><Path d="M7.50012 6L12 1.5L16.5001 6" stroke="currentColor" strokeLinecap="square"/><Path d="M12 2V13.5" stroke="currentColor" strokeLinecap="square"/><Path d="M8.50002 9.5H4.50012V20.5H19.5001V9.5H15.5001" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconShareOs;
